import React from 'react';
import ReactDOM from 'react-dom';
import Pillar from './pillar.js';

Storage.prototype.setObject = function(key, value) {
  this.setItem(key, JSON.stringify(value));
}

Storage.prototype.getObject = function(key) {
  var value = this.getItem(key);
  return value && JSON.parse(value);
}

document.addEventListener("DOMContentLoaded", function() {

  if (document.getElementById('pillar')) {
    ReactDOM.render(
      <Pillar></Pillar>,
      document.getElementById('pillar')
    );
  }

})
